import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { State } from "appworks/state-machine/states/state";
import { Timer } from "appworks/utils/timer";
import { BetBarComponent } from "slotworks/components/betbar/bet-bar-component";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";

export interface ExitFreespinsConfig {
    wait: number;
    waitOnlyWhenNoWins: boolean;
}

export class FreespinIdleState extends State {

    protected config: ExitFreespinsConfig = {
        wait: 0,
        waitOnlyWhenNoWins: false
    };

    protected waitTimer: number;

    constructor(config?: Partial<ExitFreespinsConfig>) {
        super();

        if (config) {
            this.config = { ...this.config, ...config };
        }
    }

    public onEnter() {
        this.updateFreespinsBetbar();

        if (this.shouldPlayWaitTimer()) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), this.config.wait);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }

    public onExit() {
        Components.get(AbstractMatrixComponent).resetSymbols();

        super.onExit();
    }

    protected updateFreespinsBetbar(): void {
        const game = gameState.getCurrentGame();

        Components.get(BetBarComponent).setTotalFreespins(game.getTotalFreespinsWon());
        Components.get(BetBarComponent).setFreespinsPlayed(Math.max(0, game.getFreespinsPlayed() + 1));
    }

    protected shouldPlayWaitTimer() {
        const isWaitTimeZero = this.config.wait <= 0;

        if (isWaitTimeZero) {
            return false;
        }

        if (!this.config.waitOnlyWhenNoWins) {
            return true;
        }

        const isWin = gameState.currentRecordHasSymbolWinResults() || gameState.currentRecordHasFreespinWinResults();
        const hasNoWins = !isWin;

        return hasNoWins;
    }
}
